import React from "react";
import kontakt from "../assets/kontakt.jpg";
import {BsFacebook, BsInstagram} from "react-icons/bs";
import {GrMail} from "react-icons/gr";
import { ImLocation2 } from "react-icons/im";
import { BsCalendarCheckFill } from "react-icons/bs";
import {Header} from "./index";
import {referenz, referenz2, referenz3} from "../assets";


const Referenzen = () => {
    return (
        <>
            <Header text="Referenzen" background={kontakt}/>
            <Main/>
        </>
    );
}

export default Referenzen;

const Main = () => {
    return(
        <div className="bg-gray-100 h-screen w-screen">
            <div className="flex gap-10 flex-wrap">
                    <Tile image={referenz} text="Einfamilienhaus mit Einliegerwohnung" location="Friedrichshafen" jear="2017"/>
                    <Tile image={referenz2} text="6-Familienhaus" location="Friedrichshafen" jear="2016"/>
                    <Tile image={referenz3} text="Einfamilienhaus mit Einliegerwohnung" location="Tettnang" jear="2015"/>
            </div>
        </div>
    );
}

const Tile = ({image, text, location, jear}) => {
    return (
        <div className="relative w-72 h-72 bg-white top-10 left-10 rounded-xl shadow-lg">
            <img src={image} className="p-2 rounded-xl"/>
            <h1 className="font-serif font-bold  m-2">{text}</h1>
            <div className="flex">
                <div className="ml-3 flex bg-blue-100 rounded-xl w-min px-2 my-1">
                    <ImLocation2 className="mt-1 w-4 h-4"/>
                    <h1 className="font-serif pl-2">{location}</h1>
                </div>
                <div className="ml-3 flex bg-blue-100 rounded-xl w-min px-2 my-1">
                    <BsCalendarCheckFill className="mt-1 w-4 h-4"/>
                    <h1 className="font-serif pl-2">{jear}</h1>
                </div>
            </div>
        </div>
    )
}